import { TeamMember } from './types';

export const teamMembers: TeamMember[] = [
  {
    name: 'Dr. Maria Nantongo',
    role: 'Director, CFSC',
    image: '/images/Dr-Maria-Photo.JPG',
    bio: 'Expert in development economics, climate finance, and governance. Led key contributions to Uganda\'s climate finance initiatives and development economics research. Holds a PhD in Development Economics and has made significant contributions to climate finance research and policy development.',
    social: {
      linkedin: 'https://www.linkedin.com/in/mary-nantongo-40a017178/?originalSubdomain=ug'
    }
  },
    {
    name: 'Dr. Christine Grüning',
    role: 'Co-Director, CFSC',
    image: '/images/Dr-Christine.jpg',
    bio: 'Dr. Christine Grüning is an expert in environmental economics, climate finance, and policy. She serves as Co-Director at CFSC and as Director of the Frankfurt School-UNEP Collaborating Centre for Climate & Sustainable Energy Finance, leading influential research and capacity-building initiatives. Holding a PhD from the European University Viadrina, she has advanced the field with innovative certification programs and key industry reports.',
    social: {
      linkedin: 'https://www.linkedin.com/in/christine-gruening-271896192/?originalSubdomain=de'
    }
  },
  {
    name: 'Dr. Joanes Atela',
    role: 'Co-Director, CFSC',
    image: '/images/Dr-Joanes-Atela-Photo.jpg',
    bio: 'Dr. Joanes Atela is an expert in natural resource management and climate change mitigation with over 15 years of experience advising African governments. He serves as Co-Director at CFSC and is the Founder and Executive Director of ARIN, where he has led impactful research and policy initiatives in community-based adaptation and climate action. He holds a Ph.D. in Environment and Development from the University of Leeds.',
    social: {
      linkedin: 'https://www.linkedin.com/in/joanes-atela/?originalSubdomain=ke'
    }
  },
  {
    name: 'Dr. Collin Agabalinda',
    role: 'Research Fellow, Climate Finance and Sustainable Development Specialist',
    image: '/images/Colin-Photo.jpg',
    bio: 'Seasoned expert in rural finance, climate adaptation finance, and sustainable development with over 20 years of experience. Specializes in designing, implementing, and evaluating financial inclusion initiatives. Part-time lecturer at MUBS and ICT University, mentoring postgraduate and PhD students. Certified Expert in Climate Adaptation Finance from Frankfurt School and holds a PhD in Business Administration & Sustainability.',
    social: {
      linkedin: 'https://linkedin.com/in/teko-juma'
    }
  },
  {
    name: 'Dr. Brendah Akankunda',
    role: 'Research Fellow, CFSC | Lecturer, Department of Accounting, MUBS',
    image: '/images/Dr-Brendah-Photo.png',
    bio: 'Expert in energy economics and sustainability with a PhD in Energy Economics. Has made significant contributions to energy economics research and sustainability practices, focusing on developing sustainable solutions for energy challenges.',
    social: {
      linkedin: 'https://www.linkedin.com/in/brendah-akankunda-phd-90090031/?originalSubdomain=ug'
    }
  },
  {
    name: 'Dr. Micah Abigaba',
    role: 'Research Fellow, CFSC | Lecturer, Department of Economics, MUBS',
    image: '/images/Micah-Photo.jpg',
    bio: 'Specializes in energy economics and sustainable development. Leading research in energy economics and sustainable development with a PhD in Economics, contributing to key policy developments in the field.',
    social: {
      linkedin: 'https://www.linkedin.com/in/micah-lucy-abigaba-phd-781161279/?originalSubdomain=no'
    }
  },
  {
    name: 'Paul Mugerwa',
    role: 'Research Fellow, CFSC',
    image: '/images/Paul-Mugerwa-Photo.jpg',
    bio: 'He\'s a seasoned financial economist with specialty in: ESG & Sustainability; Climate Finance, Risk & Reporting; Investment Management; and Taxation. He holds a MBA-Investment Management and he has led numerous research & capacity building initiatives.',
    social: {
      linkedin: 'https://www.linkedin.com/in/paul-mugerwa-85a7a066/?originalSubdomain=ug'
    }
  },
  {
    name: 'Vincent Mugabe',
    role: 'Administration and Communication Officer, CFSC | Publications Unit, MUBS',
    image: '/images/Vincent-Photo.jpg',
    bio: 'International business expert managing administrative and communication functions. Has streamlined administrative processes and communication strategies with a Masters in International Business.',
    social: {
      linkedin: 'https://www.linkedin.com/in/mugabe-vincent-ab0930192/?originalSubdomain=ug'
    }
  },
  {
    name: 'Jude Kamuganga',
    role: 'Research Fellow, CFSC',
    image: '/images/Jude-Photo.jpg',
    bio: 'Specialist in law, energy economics, and governance. Certified expert in climate and renewable energy finance with a Master in Energy Economics & Governance.',
    social: {
      linkedin: 'https://www.linkedin.com/in/jude-kamuganga-3023a1346/'
    }
  },
  {
    name: 'Naomi Musiimenta',
    role: 'Communications Team Lead, CFSC',
    image: '/images/Naomi-Photo.JPG',
    bio: 'Mass communication expert leading the Centre\'s communication strategies. Has developed comprehensive communication strategy for the Centre and holds a Masters in Mass Communication.',
    social: {
      linkedin: 'https://www.linkedin.com/in/naomi-musiimenta-178903249/?originalSubdomain=ug'
    }
  },
  {
    name: 'Abataki Wani Richard',
    role: 'Statistician & Research Assistant , CFSC',
    image: '/images/Richard-Photo.jpg',
    bio: 'Statistics expert supporting data analysis and research outputs. Has made key contributions to statistical analysis of research projects and holds a Masters in Statistics.',
    social: {
      linkedin: 'https://www.linkedin.com/in/richard-wani-abataki-899251299/'
    }
  }
];